import React from 'react'
import { Trans } from '@lingui/react/macro'

import { YStack } from 'tamagui'

import { Icon } from '../Icon'
import { H3, Text } from '../Text'

export const PrivateGuildGate = () => {
  return (
    <YStack
      alignItems='center'
      justifyContent='center'
      padding='$8'
      gap='$5'
      flex={1}
    >
      <Icon name='lock-closed' size='$10' color='$colorMuted' />

      <H3 size='$7'>
        <Trans>Members Only</Trans>
      </H3>

      <Text size='$5' color='$colorMuted' textAlign='center' maxWidth={400}>
        <Trans>
          This Guild is private. Join to see Events, Presentations, and members.
        </Trans>
      </Text>
    </YStack>
  )
}
